import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {User, UserService} from '../user.service';
import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {NotificationService} from '../notification.service';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  data = new BehaviorSubject<Array<User>>([]);
  searchText = new BehaviorSubject<string>('');

  dataToShow: User[];

  searchFc = new FormControl();

  changeState = new Map<string, boolean>();

  disableDeletion = true;

  disableEditing = true;

  constructor(private us: UserService, private router: Router, private ns: NotificationService) {
  }

  changeSelection(id: string, state: boolean) {
    this.changeState.set(id, state);
    this.disableDeletion = true;
    this.disableEditing = true;
    let selectionCount = 0;
    this.changeState.forEach((value, key) => {
      if (value) {
        this.disableDeletion = false;
        selectionCount++;
      }
    });
    if (selectionCount === 1) {
      this.disableEditing = false;
    }
  }

  getSelection(id: string) {
    const value = this.changeState.get(id);
    if (value) {
      return value;
    } else {
      return false;
    }
  }

  getSelectedIds(): Array<string> {
    const returnValue: Array<string> = [];
    this.changeState.forEach((value, key) => {
      if (value) {
        returnValue.push(key);
      }
    });
    return returnValue;
  }

  filterData(t: string, u: User[]): User[] {
    // console.log(`users:${JSON.stringify(u)}`);
    return u.filter((user) => {
      for (const i in user) {
        if (user.hasOwnProperty(i)) {
          // console.log(`testing user${user}:${i} = ${user[i]}`);
          if (!isNullOrUndefined(user[i]) && user[i].toString().indexOf(t) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
  }

  bulkDelete(ids: Array<string>) {
    let resultObservable: Observable<string> = Observable.from(new Array<string>());
    ids.forEach((id) => {
      resultObservable = resultObservable.concat(this.us.remove(id));
    });
    resultObservable.subscribe(
      (id) => {
        console.log(`Id ${id} successfully deleted`);
        this.data.next(this.data.getValue().filter((user) => user.username !== id));
        // console.log(`New Data: ${JSON.stringify(this.data.getValue())}`);
        this.changeSelection(id, false);
        this.ns.warning(id, 'Deletado com sucesso!');
      },
      (error) => {
        console.log(`error: ${error}`);
        this.ns.error(error.toString(), 'Erro ao deletar');
      }
    );
  }

  editData() {
    const selection = this.getSelectedIds();
    this.router.navigateByUrl('/users/' + selection[0]);
  }

  ngOnInit() {
    this.us.getAll().subscribe((users: User[]) => this.data.next(users));
    this.searchFc.valueChanges.debounceTime(250).subscribe((text) => {
      this.searchText.next(text);
      this.dataToShow = this.filterData(text, this.data.getValue());
    });
    this.data.subscribe((users: Array<User>) => {
      this.dataToShow = this.filterData(this.searchText.getValue(), users);
    });
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/user/user.component.ts